import { Box } from "../../scenes/game/components/3d/gamefield/box/Box";
import { IMinable } from "../../scenes/game/components/3d/gamefield/mines/IMinable";
import { Vegetable } from "../../scenes/game/components/3d/gamefield/Vegetable";
import { IDamageable } from "../../scenes/game/components/3d/IDamageable";

export class InterfaceCheckUtils {
    public static isMinable(obj: any): obj is IMinable {
        return obj.isMinable === true;
    }

    public static isDamageable(obj: any): obj is IDamageable {
        return obj.isDamageable === true;
    }

    public static isBox(obj: any): obj is Box {
        return obj instanceof Box;
    }

    public static isVegetable(obj: any): obj is Vegetable {
        return obj instanceof Vegetable;
    }
}